/** Time zone of each sales region: dates on a visitor's first page, until the backend sends one in the context. */
export const REGION_TIME_ZONES: Partial<Record<string, string>> = {
    CO: 'America/Bogota',
    CR: 'America/Costa_Rica',
    ES: 'Europe/Madrid',
    GT: 'America/Guatemala',
    MX: 'America/Mexico_City',
};

export const DEFAULT_TIME_ZONE = 'UTC';

/** Cookie with the browser's own time zone, so the server renders dates in it from the second page on. */
export const TIME_ZONE_COOKIE = 'nlk_tz';

export const TIME_ZONE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;
